import React from 'react'
import Button from '../../elementals/button'
import CountdownButton from '../../elementals/countdownButton'
import type { ButtonProps } from '../../elementals/button'

export interface ActionModalButtonProps extends ButtonProps {
  label: string
  style?: React.CSSProperties
  isCountdownButton?: boolean
  reInitialize?: boolean
}

export const ActionModalButton = ({
  isCountdownButton,
  label,
  disabled,
  loading,
  ...rest
}: ActionModalButtonProps) =>
  isCountdownButton ? (
    <CountdownButton
      {...rest}
      seconds={5}
      disabled={disabled || loading}
      loading={loading}
    >
      {label}
    </CountdownButton>
  ) : (
    <Button {...rest} disabled={disabled || loading}>
      {label}
    </Button>
  )
